import { observer } from "mobx-react-lite";
import useNavigateToLead from "../../hooks/useNavigateToLead";
import { formatDate } from "../../utils/utils";
import infoStyles from '../Info.module.css';
import styles from './NotificationInfo.module.css';

function LeadNotificationInfo({ leadId, name, dueDate, subject, className }: ILeadNotificationInfoProps) {
    const navigateToLead = useNavigateToLead();

    const dateNow = new Date(new Date().toJSON().substring(0, 10));

    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={() => navigateToLead(leadId)}>
            <div className={infoStyles.title}>{name}</div>
            <div className={[infoStyles.description, dateNow > dueDate ? styles.red : null].join(" ")}>
                {formatDate(dueDate)} - {subject}
            </div>
        </div>
    );
}

export default observer(LeadNotificationInfo);

interface ILeadNotificationInfoProps {
    leadId: number;
    name: string;
    dueDate: Date;
    subject: string;
    className?: string;
}